import { useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"
import { Container, Typography, Box, IconButton, Button } from "@mui/material"
import { MdArrowBack } from "react-icons/md"
import { Loader } from "../Common/Loader/loader"
import { blogSx } from "./styles"

export default function Blog() {
  const { title } = useParams()
  const navigate = useNavigate()
  const { blogData, loading, error } = useSelector((state) => state.blog)

  if (loading) {
    return (
      <Loader />
    )
  }

  if (error) {
    return (
      <Container maxWidth="md" sx={blogSx.errorContainer}>
        <Typography color="error">
          Error loading blog: {error.message || error}
        </Typography>
      </Container>
    )
  }

  const blog = blogData?.find((b) =>
    b?.url?.trim()?.toLowerCase() === title?.trim()?.toLowerCase()
  )

  if (!blog) {
    return (
      <Container
        maxWidth="md"
        sx={blogSx.notFoundContainer}
      >
        <Box sx={blogSx.notFoundBox}>
          <Typography sx={blogSx.notFoundTitle}>
            Blog Not Found
          </Typography>
          <Typography sx={blogSx.notFoundSubtitle}>
            Sorry, the blog you are looking for does not exist or may have been removed.
          </Typography>
          <Box>
            <Button variant="contained" onClick={() => window.history.back()}> Go Back </Button>
          </Box>
        </Box>
      </Container>
    )
  }

  return (
    <Container
      maxWidth="md"
      sx={blogSx.mainContainer}
    >
      <Box sx={blogSx.backButtonBox}>
        <IconButton onClick={() => navigate(-1)} color="primary">
          <MdArrowBack size={30} />
        </IconButton>
      </Box>
      <Typography
        variant="h3"
        sx={blogSx.title}
        gutterBottom
      >
        {blog.title}
      </Typography>
      <Box
        sx={blogSx.contentBox}
        dangerouslySetInnerHTML={{ __html: blog.content }}
      />
    </Container>
  )
}
